import { COMPANY_ACTION_TYPES } from '../constants';
import { 
	APP_CONSTANTS,
	GLOBAL_CONSTANTS,
} from '../../../constants';
import { COMPANY_CONSTANTS } from '../constants';

import { createErrorMessageFromJsonResponse } from '../../../utilities';

import { companyServices } from '../../../api/services';



function requestGetPaginateCompanyList(page,limit,sortBy){
	return {
		type: COMPANY_ACTION_TYPES.GET_PAGINATE_COMPANY_LIST_REQUEST
	}
}

function successGetPaginateCompanyList(companyList,page,limit,sortBy){
	return {
		type: COMPANY_ACTION_TYPES.GET_PAGINATE_COMPANY_LIST_SUCCESS,
		companyList,
		page,
		limit,
		sortBy,
	}
}

function successGetPaginateCompanyListAddMore(companyList,page,limit,sortBy){
	return {
		type: COMPANY_ACTION_TYPES.GET_PAGINATE_COMPANY_LIST_SUCCESS_ADD_MORE,
		companyList,
		page,
		limit,
		sortBy,
	}
}

function failureGetPaginateCompanyList(error){
	return {
		type: COMPANY_ACTION_TYPES.GET_PAGINATE_COMPANY_LIST_FAILURE,
		error,
	}
}

function emptyGetPaginateCompanyList(error){
	return {
		type: COMPANY_ACTION_TYPES.GET_PAGINATE_COMPANY_LIST_EMPTY,
		error,
	}
}

function getPaginateCompanyList(page, limit, sortBy){
	return async (dispatch,getState) => {

    	var { token } = getState().auth;
    	if(!token){
    		token = await localStorage.getItem('token');
    	}


    	if(token){
    		try{
    			await dispatch(requestGetPaginateCompanyList());

    			//## Get Only Job below available JOb
    			let filterBy = {
    				
    			}

    			let select = null;

    			if(!sortBy){
    				sortBy = APP_CONSTANTS.DEFAULT_PAGINATION_SORT_BY;
    			}

    			let payload = {
    				page: page,
    				limit: limit,
    				filterBy: filterBy,
    				sortBy: sortBy,
    				select: select,
    			}

    			let responseJson = await companyServices.getPaginateCompanyList(
						    				token,
						    				payload
						    			);



				if(responseJson){
					if(responseJson.code === GLOBAL_CONSTANTS.CODE_SUCCESS){
						if(responseJson.data){
							// if(page === 0){
							// 	await dispatch(
							// 		successGetPaginateCompanyList(
							// 			responseJson.data,
							// 			page,
							// 			limit,
							// 			sortBy,
							// 		)
							// 	);
							// }
							// else if(page > 0){
							// 	await dispatch(
							// 		successGetPaginateCompanyListAddMore(
							// 			responseJson.data,
							// 			page,
							// 			limit,
							// 			sortBy,
							// 		)
							// 	);
							// }

							await dispatch(
								successGetPaginateCompanyList(
									responseJson.data,
									page,
									limit,
									sortBy,
								)
							);

		                    return responseJson.data;
		                }
		                else{
		                	await dispatch(
		                		emptyGetPaginateCompanyList(
		                			COMPANY_CONSTANTS.ERROR_FAILURE_PAGINATE_COMPANY
		                		)
		                	);
		                	return null;
		                }

					}
					else if(responseJson.response) {

	                    var errMsg = createErrorMessageFromJsonResponse(responseJson.response.data);
	                        await dispatch(
	                        	failureGetPaginateCompanyList(errMsg)
	                        );
	                    return null;
	                }
					else if(responseJson.requestError) {
	                    await dispatch(
	                    	failureGetPaginateCompanyList(
	                    		responseJson.requestError
	                    	)
						);
	                    return null;
	                }
	                else{
	                    await dispatch(
							failureGetPaginateCompanyList(
								COMPANY_CONSTANTS.ERROR_FAILURE_PAGINATE_COMPANY
							)
						);
		                return null;
	                }
				}
				else{
					await dispatch(
						failureGetPaginateCompanyList(
							COMPANY_CONSTANTS.ERROR_FAILURE_PAGINATE_COMPANY
						)
					);
	                return null;
				}
    		}
    		catch(error){
    			await dispatch(
    				failureGetPaginateCompanyList(
    					error.message
    				)
    			);
	    		return null;
    		}
    	}
    	else{
    		await dispatch(
    			failureGetPaginateCompanyList(
    				APP_CONSTANTS.ERROR_UNAUTHORIZED_REQUEST
    			)
    		);
	    	return null;
    	}
    }
}


//##-------------------------------------------------------------------------
function requestCountPaginateCompanyList(page,limit,sortBy){
	return {
		type: COMPANY_ACTION_TYPES.COUNT_PAGINATE_COMPANY_LIST_REQUEST
	}
}

function successCountPaginateCompanyList(companyListTotalNum){
	return {
		type: COMPANY_ACTION_TYPES.COUNT_PAGINATE_COMPANY_LIST_SUCCESS,
		companyListTotalNum,
	}
}

function failureCountPaginateCompanyList(error){
	return {
		type: COMPANY_ACTION_TYPES.COUNT_PAGINATE_COMPANY_LIST_FAILURE,
		error,
	}
}

function emptyCountPaginateCompanyList(error){
	return {
		type: COMPANY_ACTION_TYPES.COUNT_PAGINATE_COMPANY_LIST_EMPTY,
		error,
	}
}

function countPaginateCompanyList(filterBy){
	return async (dispatch,getState) => {

    	var { token } = getState().auth;
    	if(!token){
    		token = await localStorage.getItem('token');
    	}


    	if(token){
    		try{
    			await dispatch(requestCountPaginateCompanyList());

    			//## Get Only Job below available JOb



    			let responseJson = await companyServices
    			.getCountTotalCompanyNum(
					token,						    				
    				filterBy
    			);



				if(responseJson){
					if(responseJson.code === GLOBAL_CONSTANTS.CODE_SUCCESS){
						if(responseJson.data){

							await dispatch(
								successCountPaginateCompanyList(
									responseJson.data
								)
							);

							return responseJson.data;
		                }
		                else{
		                	await dispatch(
		                		emptyCountPaginateCompanyList(
		                			COMPANY_CONSTANTS.ERROR_EMPTY_COUNT_PAGINATE_COMPANY
		                		)
		                	);
		                	return null;
		                }

					}
					else if(responseJson.response) {

	                    var errMsg = createErrorMessageFromJsonResponse(responseJson.response.data);
	                        await dispatch(
	                        	failureCountPaginateCompanyList(errMsg)
	                        );
	                    return null;
	                }
					else if(responseJson.requestError) {
	                    await dispatch(
	                    	failureCountPaginateCompanyList(
	                    		responseJson.requestError
	                    	)
						);
	                    return null;
	                }
	                else{
	                    await dispatch(
							failureCountPaginateCompanyList(
								COMPANY_CONSTANTS.ERROR_FAILURE_COUNT_PAGINATE_COMPANY
							)
						);
		                return null;
	                }
				}
				else{
					await dispatch(
						failureCountPaginateCompanyList(
							COMPANY_CONSTANTS.ERROR_FAILURE_COUNT_PAGINATE_COMPANY
						)
					);
	                return null;
				}
    		}
    		catch(error){
    			await dispatch(failureCountPaginateCompanyList(error.message));
	    		return null;
    		}
    	}
    	else{
    		await dispatch(
    			failureCountPaginateCompanyList(
    				APP_CONSTANTS.ERROR_UNAUTHORIZED_REQUEST
    			)
    		);
	    	return null;
    	}
    }
}


export const companyListActions = {

	requestGetPaginateCompanyList,
	successGetPaginateCompanyList,
	successGetPaginateCompanyListAddMore,
	failureGetPaginateCompanyList,
	emptyGetPaginateCompanyList,
	getPaginateCompanyList,


	requestCountPaginateCompanyList,
	successCountPaginateCompanyList,
	failureCountPaginateCompanyList,
	emptyCountPaginateCompanyList,
	countPaginateCompanyList,


}